// The Vue build version to loading with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Root from './root'
import router from './router/router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es'
import store from './store/store'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'

Vue.config.productionTip = false
Vue.use(ElementUI, {locale})

/* eslint-disable no-new */
new Vue({
  el: '#root',
  store,
  router,
  render: h => h(Root)
})



// WEBPACK FOOTER //
// ./src/main.js